import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { DataResponse, GameType, ItemType } from "@apiserver-rest/ponder-data-client-base";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { DisplayErrorEvent } from "@ponder-core/events/ui.events";
import { itemTypeToId } from "@ponder-shared/utils/enumConverter";
import { gameTypeToId } from "@ponder-shared/utils/gameInfo";
import { take } from "rxjs";

@Component({
    selector: "item-collection-count",
    imports: [NgClass],
    templateUrl: "./item-collection-count.component.html"
})
export class ItemCollectionCountComponent {
    @Input({ required: true }) public game!: GameType;
    @Input({ required: true }) public itemType!: ItemType;
    @Input({ required: true }) public itemId!: string;
    @Input({ required: true }) public hasNormalVersion!: boolean;
    @Input({ required: true }) public hasSpecialVersion!: boolean;
    @Input({ required: true }) public count!: number;
    @Input({ required: true }) public specialCount!: number;
    @Input({ required: true }) public proxyCount!: number;

    public processing: boolean = false;

    private gameId!: number;
    private itemTypeId!: number;

    public constructor(private ponderDataClient: PonderDataClient, private events: EventBroker) {
        
    }

    public ngOnInit() {
        this.gameId = gameTypeToId(this.game);
        this.itemTypeId = itemTypeToId(this.itemType);
    }

    public adjustNormalCount(n: number): void {
        this.adjustCount(n, 0, 0);
    }

    public adjustSpecialCount(n: number): void {
        this.adjustCount(0, n, 0);
    }

    public adjustProxyCount(n: number): void {
        this.adjustCount(0, 0, n);
    }

    private adjustCount(normal: number, special: number, proxy: number): void {
        if (this.processing) {
            return;
        }

        this.processing = true;

        var updatedNormalCount = this.count + normal;
        var updatedSpecialCount = this.specialCount + special;
        var updatedProxyCount = this.proxyCount + proxy;

        if ((updatedNormalCount < 0) || (updatedNormalCount > 1024) || (updatedSpecialCount < 0) || (updatedSpecialCount > 1024) || (updatedProxyCount < 0) || (updatedProxyCount > 1024)) {
            // Can't have negative collected, and don't exceed our arbitrary limit of 1024. tbd if thats needed/wanted
            this.processing = false;
            return;
        }

        // Immediately update the rendered count for UI responsiveness (this may be rolled back if API returns error)
        this.count = updatedNormalCount;
        this.specialCount = updatedSpecialCount;
        this.proxyCount = updatedProxyCount;

        this.ponderDataClient
            .collectionItem(this.itemId, normal, special, proxy, this.gameId, this.itemTypeId)
            .pipe(take(1))
            .subscribe( {
                // Rollback the previous UI update if error
                next: (response: DataResponse) => {
                    this.count -= (response.success ? 0 : normal);
                    this.specialCount -= (response.success ? 0 : special);
                    this.proxyCount -= (response.success ? 0 : proxy);
                    this.processing = false;

                    if (response.error) {
                        this.events.ui.displayErrorEvent.emit({
                            message: response.error
                        });
                    }
                },
                error: (_: any) => {
                    this.count -= normal;
                    this.specialCount -= special;
                    this.proxyCount -= proxy;
                    this.processing  = false;
                }
            })
    }
}